import { DEFAULT_REGION, LANGUAGES, STORAGE_KEY } from "../../i18n/languages.js"
import { isLangParamEnabled, readLangParam, regionToUrlLang, resolveRegion, urlLangToRegion } from "../../i18n/urlLang.js"

const COUNTRY_STORAGE_KEY = "userCountry"

const FALLBACK_MARKET = process.env.GATSBY_STORE !== "PH"
	? { site_country: "US", site_currency: "USD" }
	: { site_country: "PH", site_currency: "PHP" }

const readStorage = (key) => {
	try {
		return window.localStorage.getItem(key)
	} catch {
		return null
	}
}

const regionFromUrl = () => {
	if (!isLangParamEnabled()) return null
	return urlLangToRegion(readLangParam(window.location.search))
}

const readEntry = () => {
	if (typeof window === "undefined") return { region: DEFAULT_REGION, source: "default" }
	const fromUrl = regionFromUrl()
	if (fromUrl) return { region: fromUrl, source: "url" }
	const stored = resolveRegion(readStorage(STORAGE_KEY))
	if (stored) return { region: stored, source: "saved" }
	return { region: DEFAULT_REGION, source: "default" }
}

let current = readEntry()
let market = null

const readMarket = () => {
	if (market) return market
	if (typeof window === "undefined") return FALLBACK_MARKET
	const raw = readStorage(COUNTRY_STORAGE_KEY)
	if (!raw) return FALLBACK_MARKET
	try {
		const parsed = JSON.parse(raw)
		market = {
			site_country: parsed?.countryCode || FALLBACK_MARKET.site_country,
			site_currency: parsed?.currencyCode || FALLBACK_MARKET.site_currency,
		}
		return market
	} catch {
		return FALLBACK_MARKET
	}
}

export const publishAnalyticsLocale = ({ region, source }) => {
	if (!region) return
	current = { region, source: source || current.source }
}

export const getAnalyticsContext = () => {
	const entry = LANGUAGES.find((l) => l.code === current.region) || LANGUAGES[0]
	return {
		site_language: regionToUrlLang(current.region) || entry.urlLang,
		site_locale: entry.locale,
		language_source: current.source,
		...readMarket(),
	}
}
